<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title primary-title class="mb-6 pt-3">
        <div class="ml-2">
          {{ $t('vmail.cfg.greeting.upload.title', { name: name }) }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon class="ma-0" @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-file-input
          accept="audio/wav"
          outlined
          clearable
          :rules="rules"
          show-size
          v-model="file"
          prepend-icon=""
          prepend-inner-icon="mdi-upload"
          :label="$t('vmail.cfg.greeting.upload.label')">
        </v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel" text>
          {{ $t('vmail.cfg.greeting.btnCancel') }}
        </v-btn>
        <v-btn @click="upload" :disabled="!readyUpload" color="primary" text>
          {{ $t('vmail.cfg.greeting.btnUpload') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'vmail-greeting-upload',
  data () {
    return {
      file: null,
      rules: [
        val => this.validType(val) || this.$t('vmail.cfg.err.uploadType'),
        val => this.validSize(val) || this.$t('vmail.cfg.err.uploadSize')
      ]
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    }
  },
  computed: {
    readyUpload: function () {
      return this.file && this.validType(this.file) && this.validSize(this.file)
    }
  },
  methods: {
    cancel: function () {
      this.file = null
      this.$emit('cancel')
    },
    upload: function () {
      this.$emit('save-file', this.file)
    },
    validType: function (val) {
      return ['audio/wav', 'audio/x-wav'].includes(val?.type)
    },
    validSize: function (val) {
      return val && val.size <= (Math.pow(1024, 2) * 2)
    },
    restore: function () {
      this.$emit('restore-archive')
      this.cancel()
    }
  }
}
</script>

<style scoped>
</style>
